import { useNls } from '../../nls/nlsProvider'
import './rollCallRow.css'

export type RollCallStatus = 'P' | 'A' | 'L' | 'OL'

export interface RollCallRowProps {
  rollNumber?: string
  name: string
  status: RollCallStatus
  locked?: boolean
  onChange: (next: RollCallStatus) => void
  disabled?: boolean
  testId?: string
  statusLabels?: Record<RollCallStatus, string>
  className?: string
}

export const RollCallRow = ({
  rollNumber,
  name,
  status,
  locked = false,
  onChange,
  disabled = false,
  testId,
  statusLabels,
  className,
}: RollCallRowProps) => {
  const { t } = useNls()

  const defaultStatusLabels: Record<RollCallStatus, string> = {
    P: t('NLSEduAttendanceStatusPresent') || 'Present',
    A: t('NLSEduAttendanceStatusAbsent') || 'Absent',
    L: t('NLSEduAttendanceStatusLate') || 'Late',
    OL: t('NLSEduAttendanceStatusOnLeave') || 'On leave',
  }

  const isLocked = locked || status === 'OL'
  const isButtonDisabled = disabled || isLocked

  const handleClick = () => {
    if (isButtonDisabled) return
    const nextStatus: RollCallStatus = status === 'P' ? 'A' : status === 'A' ? 'L' : 'P'
    onChange(nextStatus)
  }

  const statusWord = statusLabels?.[status] ?? defaultStatusLabels[status]
  const buttonAriaLabel = `${name} ${statusWord}`

  return (
    <div
      className={['rollCallRow', className].filter(Boolean).join(' ')}
      data-testid={testId}
    >
      <div className="rollCallRow__identity">
        {rollNumber ? (
          <span className="rollCallRow__number" data-testid={testId ? `${testId}-number` : undefined}>
            {rollNumber}
          </span>
        ) : null}
        <span className="rollCallRow__name" data-testid={testId ? `${testId}-name` : undefined}>
          {name}
        </span>
      </div>
      <button
        type="button"
        className={[
          'rollCallRow__statusButton',
          `rollCallRow__statusButton--${status}`,
          isLocked ? 'rollCallRow__statusButton--locked' : '',
        ].filter(Boolean).join(' ')}
        onClick={handleClick}
        disabled={isButtonDisabled}
        aria-label={buttonAriaLabel}
        data-testid={testId ? `${testId}-status` : 'roll-call-status-btn'}
      >
        {status}
      </button>
    </div>
  )
}

export default RollCallRow
